import React, { useState } from 'react';
import Styles from './LanguageChange.module.less'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import LanguageList from '../config/LanguageList'
import LanguageMap from '../config/LanguageMap'

const ChangeLanguage = () => {
  const {i18n} = useTranslation()
  const [showPannelStatus, setPannelStatus] = useState(false)

  const openNewTab = lang => {
    if ( LanguageMap[lang] === i18n.language) {
      return
    }
    console.log(LanguageList, 'LanguageList')
    console.log(lang, 'langlang')
    window.open(`${window.location.origin}/${lang}/`)
    setPannelStatus(false)
  }

  return (
    <div className={Styles['language']}>
      {/* <span onClick={() => setPannelStatus(!showPannelStatus)} className={classnames('language-detail', {'language-detail_open': showPannelStatus} )}>
        {LanguageList[i18n.language]}
      </span> */}

        {Object.keys(LanguageList).map((key, index) => {
          if(key !== i18n.language)
          return (
            <span
            onClick={() => openNewTab(key)} 
            key={key} 
            className={classnames('language-detail')}>
              {LanguageList[key]}
            </span>
          )
        })}
      
      {/* <div className={classnames('lan-pannel', {'lan-pannel_hide': !showPannelStatus})}>
        {Object.keys(LanguageList).map((key, index) => (
          <span
          onClick={() => openNewTab(key)} 
          key={key} 
          className={classnames({'active': key === i18n.language})}>
            <div>{LanguageList[key]}</div>
          </span>
        ))}
      </div> */}
    </div>
  )
}

export default ChangeLanguage;
